module.exports = __webpack_public_path__ + "img/password-updated.2d832da9.png";